<template>

    <main class="temoignages-body-template">
        <article>
            <section class="text-right">
                <figure>
                    <img class="picture" v-if="item.picture" :src="require('../../assets/' + item.picture)" alt="">
                    <figcaption>
                        <p :class="item.color">AURÉLIE ORNON</p>
                        <p class="green">Responsable forêts à <br />Marcheprime (33)</p>
                    </figcaption>
                </figure>


                <p class="number" :class="item.color">
                   76,1 Mds €
                <p class="green uppercase semiBold">
                    d'encours de Groupama Asset Management en investissements responsables.
                </p>


                <img class="icono w300" :src="require('../../assets/t7-2.jpg')">
                <p class="label green">
                    INVESTISSEMENTS RESPONSABLES

                <p class="green uppercase semiBold">
                   Une prise de participation en France aux côtés de la banque des territoires dans Predica Energies Durables (PED) dédiée aux investissements dans la production d’énergies solaire et éolienne en France.
                </p>

                <p class="label green">
                    PORPHYRE CLIMAT SEPTEMBRE 2019

                <p class="green uppercase semiBold">
                  Le premier titre de créance vert en unités de compte, 100 % engagé dans la transition énergétique.

                </p>


            </section>

            <section>
                <svg class="quote" :class="item.color" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.8 42.61">
                    <path d="M59.8,0H45.59C39,11,34.91,18,33.43,20.83a17.92,17.92,0,0,0-2.17,8.26c0,7.57,6.36,13.52,14.34,13.52s14.2-6,14.2-13.52c0-5.28-2.7-9.2-8.11-11.5ZM28.55,0H14.21C7.57,11.09,3.65,18.13,2.16,21A17.49,17.49,0,0,0,0,29.09c0,7.57,6.22,13.52,14.2,13.52s14.2-6,14.2-13.52c0-5.28-2.7-9.2-8.11-11.5Z"/>
                </svg>
                <h2>Nos forêts compensent largement les émissions carbones du Groupe et s’intègrent dans un processus
                    vertueux.</h2>
                <h1>
                    <span>S’ENGAGER AUX CÔTÉS </span>
                    <span>D’AURÉLIE ET DE TOUS </span>
                    <span>NOS PARTENAIRES</span>
                    <span>Pour <em :class="item.color">UNE FINANCE</em></span>
                    <span><em :class="item.color">plus RESPONSABLE</em></span>
                </h1>

                <!--<h3>
                    à la tête d'une exploitation<br>
                    de 350 HA, en blé, colza et orge
                </h3>-->

                <p>
                    Aurélie travaille chez Groupama depuis 20 ans. Fille de forestiers, elle est maintenant responsable
                    du secteur Gironde de la Société Forestière Groupama qui représente 6 700 hectares. Grand
                    gestionnaire de forêts en France, avec près de <span class="marker" :class="item.color">22 000 hectares de forêts en portefeuille</span>,
                    Groupama Immobilier dispose d’un patrimoine végétal remarquable. L’histoire du Groupe puise ses
                    sources dans la terre et son président Jean-Yves Dagès est lui-même particulièrement impliqué en
                    étant à la tête du Comité Forêt de Groupama.
                    <br><br>
                    Véritable passionnée, le travail d’Aurélie consiste à établir les feuilles de route pour la gestion
                    de la forêt : marquage des arbres destinés à être coupés ou vendus, travaux sylvicoles et de
                    reboisement ou encore installation de tracteurs avec des entreprises extérieures.
                    <br><br>
                    Pour elle, faire partie d’un grand groupe comme Groupama est une valeur sûre et lui donne accès à
                    des expertises privilégiées telles que celles de l’INRA par exemple, l’Institut National de la
                    Recherche Agronomique.
                    <br><br>
                    Chez Groupama, la forêt a de la valeur. Sa gestion s’inscrit dans une démarche de développement
                    durable et une vision à long terme. «&nbsp;Aujourd’hui on parle davantage des forêts, chez Groupama
                    nous avons commencé à changer bien avant les préoccupations environnementales&nbsp;»
                    témoigne-t-elle. «&nbsp;Nos forêts compensent largement les émissions carbones du Groupe et
                    s’intègrent dans un processus vertueux&nbsp;». Certifiées PEFC, Programme de Reconnaissance des
                    Certifications Forestières, ce label se superpose au Plan Simple de Gestion, le PSG, dont l’objectif
                    est d’assurer une gestion durable. Il impose à Groupama un cahier des charges à respecter et la
                    traçabilité du bois de la forêt aux destinataires finaux.
                </p>

                <a href="" class="link">
                    <svg class="link-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 324">
                        <path d="M239,260v56a7.89,7.89,0,0,1-8,8H40A40.12,40.12,0,0,1,0,284V40A40.12,40.12,0,0,1,40,0H242c4,0,8,4,8,8V252a7.89,7.89,0,0,1-8,8Zm-16,16V260H40a23.69,23.69,0,0,0-24,24c0,14,10,24,24,24H223V292H37V276Zm11-31V16H40C26,16,16,26,16,40V253c7-5,14-8,24-8Z"/>
                        <path d="M197,64v61H52V64ZM183,78H67v33H183Z"/>
                    </svg>
                    <div class="link-content">
                        <p>Retrouvez tous les faits qui ont marqué notre année</p>
                        <p><span>Télécharger</span> le rapport annuel</p>
                    </div>
                </a>

            </section>
        </article>
    </main>


</template>

<script>

    export default {
        name: "TemoignageBody",
        props: ['item'],
        mounted() {

            window.removeEventListener('scroll', this.scroll)
            window.addEventListener('scroll', this.scroll)

        },
        methods: {
            scroll() {
                if(!document.querySelector('.temoignages-item-bar.active'))
                    return;

                if (this.isInViewport(document.querySelector('.temoignages-item-bar.active')))
                    document.querySelector('.temoignages-item-bar.active + .temoignages-item-content .close').style.opacity = 0;
                else
                    document.querySelector('.temoignages-item-bar.active + .temoignages-item-content .close').style.opacity = 1;
            },
            isInViewport(elem) {
                let bounding = elem.getBoundingClientRect();
                return (
                    bounding.top >= -document.querySelector('.temoignages-item-bar.active').clientHeight &&
                    bounding.left >= 0 &&
                    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            }
        }
    }
</script>
